module.exports = __webpack_public_path__ + "img/tpc-19.084199be.jpg";